import {
  Button,
  Checkbox,
  Container,
  FormControlLabel,
  FormHelperText,
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import '../styles/login.scss'
import GoogleLogo from '../assets/imgs/google-logo.svg'
import FacebookLogo from '../assets/imgs/facebook-logo.svg'
import TwitterLogo from '../assets/imgs/twitter-logo.svg'
import { Link, useNavigate } from 'react-router-dom'
import SignUpGroupImage from '../assets/imgs/sign-up-images-group.png'
import CustomInput from './styled/CustomInput.styled'
import RegistrationModal from '../modals/RegistrationModal'
import CheckboxUnchecked from '../assets/imgs/unchecked-checkbox.svg'
import CheckboxChecked from '../assets/imgs/checked-checkbox.svg'
import TermsAndConditionsModal from '../modals/TermsAndConditionsModal'
import { saveOrUpdateDataById } from '../apis/generalApis'
import { useDispatch } from 'react-redux'
import { setUser } from '../app/features/user/userSlice'
import { registerUser } from '../apis/userApis'
import IdentityProofDocumentsModal from '../modals/IdentitiyProofDocumentsModal'
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

function SignUp() {
  const [toggleRegistrationModal, setToggleRegistrationModal] = useState(false)
  const handleRegistrationModal = () => {
    setToggleRegistrationModal((prev) => !prev)
  }
  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)
  const [termsAndConditionsModal, setTermsAndConditionsModal] = useState(false)
  const [
    identityProofDucumentsModal,
    setIdentityProofDucumentsModal,
  ] = useState(false)
  const [acceptTermsAndConditions, setAcceptTermsAndConditions] = useState(
    false,
  )
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [userDetails, setUserDetails] = useState({})

  const handleUserRegistration = async (e) => {
    e.preventDefault()
    if (
      // newUser?.confirm_password !== '' &&
      // newUser?.name !== '' &&
      // newUser?.email != '' &&
      // newUser?.password !== '' &&
      // newUser?.accept_terms_and_conditions === true &&
      newUser?.password === newUser?.confirm_password
    ) {
      // handleIdentityProofDocumentsModal()
      let body = {
        first_name: newUser.first_name,
        last_name: newUser.last_name,
        email: newUser.email,
        password: newUser.password,
        password_confirmation: newUser.confirm_password,
        user_type: 'client',
      }
      setUserDetails({ ...body })
      handleRegistrationModal()
      // let result = await registerUser('user-register', body)
      // if (result?.data != null && result?.data?.success === true) {
      //   handleIdentityProofDocumentsModal()
      //   localStorage.setItem('user', JSON.stringify(result?.data?.data))
      //   dispatch(setUser({ user: result?.data?.data }))
      // }
    }
  }

  const handleTermsAndConditionsModal = (value) => {
    if (value === false) {
      setAcceptTermsAndConditions(true)
    }
    setTermsAndConditionsModal(!termsAndConditionsModal)
  }
  const handleIdentityProofDocumentsModal = () => {
    setIdentityProofDucumentsModal((prev) => !prev)
  }

  const [newUser, setNewUser] = useState({
    first_name: '',
    last_name: '',
    name: '',
    email: '',
    password: '',
    confirm_password: '',
    accept_terms_and_conditions: false,
    birthday: '',
    location: '',
    gender: '',
    title: '',
    about: '',
  })

  const handleChange = (e) => {
    setNewUser({ ...newUser, [e.target.name]: e.target.value })
  }
  useEffect(() => {
    if (acceptTermsAndConditions === true) {
      setNewUser({ ...newUser, accept_terms_and_conditions: true })
    }
  }, [acceptTermsAndConditions])

  return (
    <>
      <Container className="mt-5">
        <div className="row" spacing={{ xs: 0, md: 2 }}>
          <div
            className="p-0 d-none d-sm-none d-md-block col-md-6"
            style={{
              height: '70vh',
            }}
          >
            <div className="h-100 text-center position-relative">
              <img src={SignUpGroupImage} alt="" />
            </div>
            <div className="position-absolute"></div>
          </div>
          <div
            item
            xs={12}
            md={8}
            className="col-12 col-sm-12 col-md-6 d-flex justify-content-center align-items-center flex-column"
          >
            <div className="signupFormWrapper">
              <h3 className="createAccHeading">Create an Account</h3>
              <form onSubmit={handleUserRegistration}>
                <div className="row">
                  <div className="col-6">
                    <FormHelperText
                      className="mt-2"
                      id="input-label"
                      margin="dense"
                    >
                      First Name
                    </FormHelperText>
                    <CustomInput
                      margin="dense"
                      name="first_name"
                      placeholder="John"
                      fullWidth={true}
                      onChange={handleChange}
                      type="text"
                      value={newUser?.first_name}
                      required
                    />
                  </div>
                  <div className="col-6">
                    <FormHelperText
                      className="mt-2"
                      id="input-label"
                      margin="dense"
                    >
                      Last Name
                    </FormHelperText>
                    <CustomInput
                      margin="dense"
                      name="last_name"
                      placeholder="Doe"
                      fullWidth={true}
                      onChange={handleChange}
                      type="text"
                      value={newUser?.last_name}
                      required
                    />
                  </div>
                </div>
                <FormHelperText
                  className="mt-2"
                  id="input-label"
                  margin="dense"
                >
                  Email
                </FormHelperText>
                <CustomInput
                  margin="dense"
                  placeholder="janedoe@mail.com"
                  id="email"
                  name="email"
                  fullWidth={true}
                  onChange={handleChange}
                  type="email"
                  value={newUser?.email}
                  required
                />
                <FormHelperText
                  className="mt-2"
                  id="input-label"
                  margin="dense"
                >
                  Password
                </FormHelperText>
                {/* <CustomInput
                  margin="dense"
                  name="password"
                  placeholder="••••••••••••"
                  fullWidth={true}
                  onChange={handleChange}
                  type="password"
                  required
                  value={newUser?.password}
                /> */}
                <OutlinedInput
                  margin="dense"
                  name="password"
                  placeholder="••••••••••••"
                  fullWidth={true}
                  onChange={handleChange}
                  required
                  value={newUser?.password}
              type={showPassword ? 'text' : 'password'}
              endAdornment={
               <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => setShowPassword(prev => !prev)}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff sx={{width: '1rem'}} /> : <Visibility sx={{width: '1rem'}} />}
                </IconButton>
              </InputAdornment>
            }
            label="Password"
          />
                <FormHelperText
                  id="input-label"
                  margin="dense"
                  className="mt-2"
                >
                  Confirm Password
                </FormHelperText>
                {/* <CustomInput
                  margin="dense"
                  placeholder="••••••••••••"
                  id="confirm-password"
                  name="confirm_password"
                  fullWidth={true}
                  onChange={handleChange}
                  required
                  type="password"
                  value={newUser?.confirm_password}
                /> */}
                <OutlinedInput
                margin="dense"
                  placeholder="••••••••••••"
                  id="confirm-password"
                  name="confirm_password"
                  fullWidth={true}
                  onChange={handleChange}
                  required
                  value={newUser?.confirm_password}
              type={showConfirmPassword ? 'text' : 'password'}
              endAdornment={
               <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() => setShowConfirmPassword(prev => !prev)}
                  edge="end"
                >
                  {showConfirmPassword ? <VisibilityOff sx={{width: '1rem'}} /> : <Visibility sx={{width: '1rem'}} />}
                </IconButton>
              </InputAdornment>
            }
            label="Password"
          />
                <div className="my-1 mx-0 d-flex justify-content-start align-items-center gap-2">
                  <Checkbox
                  sx={{padding: 0}}
                  className="my-2"
                    checked={acceptTermsAndConditions}
                    checkedIcon={
                      <CheckCircleIcon sx={{color: "#08C4BB", width: '1rem'}} />
                    }
                    onChange={(e) =>
                      setAcceptTermsAndConditions(e.target.checked)
                    }
                    icon={
                      <RadioButtonUncheckedIcon sx={{color: "#08C4BB", width: '1rem'}} />
                    }
                    required
                  />
                  <p
                    className="fs-12 font-weight-bold pointer"
                    onClick={handleTermsAndConditionsModal}
                  >
                    Terms and Conditions
                  </p>
                </div>
                <Button
                  disableElevation
                  id="btn-primary-no-shadow"
                  variant="contained"
                  fullWidth={true}
                  className="pointer"
                  type="submit"
                  // onClick={}
                >
                  Sign Up
                </Button>
                <p className="mt-3">Or continue with</p>
                {/* <div className="social-media-wrapper">
                  <img src={GoogleLogo} alt="Google Sign Up" height={26} />
                  <img src={FacebookLogo} alt="Facebook Sign Up" height={26} />
                  <img src={TwitterLogo} alt="Twitter Sign Up" height={26} />
                </div> */}
                <div className="d-flex justify-content-around align-items-center my-4 mx-0">
                  <img src={GoogleLogo} alt="Google Logo" height={26} />
                  <img src={FacebookLogo} alt="Facebook Logo" height={26} />
                  <img src={TwitterLogo} alt="Twitter Logo" height={26} />
                </div>
                <p className="mb-2">Already have an account?</p>
                <Link className="text-decoration-none" to="/login">
                  <Button
                    variant="outlined"
                    id="btn-transparent"
                    disableElevation
                    fullWidth={true}
                    className="text-capitalize"
                  >
                    Login
                  </Button>
                </Link>
              </form>
            </div>
          </div>
        </div>
      </Container>
      <RegistrationModal
        handleRegistrationModal={handleRegistrationModal}
        modalOpen={toggleRegistrationModal}
        userDetails={userDetails}
      />
      <TermsAndConditionsModal
        handleTermsAndConditionsModal={handleTermsAndConditionsModal}
        modalOpen={termsAndConditionsModal}
        setAcceptTermsAndConditions={setAcceptTermsAndConditions}
      />
      <IdentityProofDocumentsModal
        handleIdentityProofDocumentsModal={handleIdentityProofDocumentsModal}
        modalOpen={identityProofDucumentsModal}
        component={'sign-up'}
      />
    </>
  )
}

export default SignUp
